import { render, staticRenderFns } from "./Establishments.vue?vue&type=template&id=45fbcd9c&scoped=true&"
import script from "./Establishments.vue?vue&type=script&lang=js&"
export * from "./Establishments.vue?vue&type=script&lang=js&"
import style0 from "./Establishments.vue?vue&type=style&index=0&id=45fbcd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbcd9c",
  null
  
)

export default component.exports